module.exports = __webpack_public_path__ + "img/branton-menu.e035eb00.jpg";